import {
  faAddressCard,
  faReceipt,
  faGift,
  faQuestionCircle,
  faAd,
  faRssSquare,
  faCertificate,
  faDollarSign,
  faTicketAlt,
  faBuilding,
  faHome,
  faSuperscript,
  faCalendarAlt,
  faBell,
  faUser,
  faInbox,
  faParking,
  faCalendarCheck,
  faPlus,
  faRss,
  faUserCircle,
  faTable,
  faCarRear,
  faBolt,
  faIdBadge,
  faHouseUser,
  faSquareParking,
  faBullseye,
  faCity,
  faAdd,
  faImage,
  faImages,
  faStamp,
  faGem,
  faRectangleList
} from "@fortawesome/free-solid-svg-icons";

let options = [
  {
    key: "member",
    label: "sidebar.member",
    leftIcon: faAddressCard,
    requiredPermissionSets: [[{ section: "MEMBER", function: "LIST" }]],
  },
  {
    key: "sinoClubMember",
    label: "sidebar.sinoclubmember",
    leftIcon: faIdBadge,
    requiredPermissionSets: [[{ section: "SINO_CLUB", function: "LIST_MEMBER" }]],
  },
  {
    key: "sinoClubMembershipUpgrade",
    label: "sidebar.sinoclubmemberupgrade",
    leftIcon: faHouseUser,
    requiredPermissionSets: [[{ section: "SINO_CLUB", function: "LIST_MEMBERSHIP_UPGRADE" }]],
  },
  {
    key: "sinoClubPMemberReferralCode",
    label: "sidebar.sinoClubPMemberReferralCode",
    leftIcon: faAdd,
    requiredPermissionSets: [[{ section: "SINO_CLUB", function: "LIST_PRIVILEGE_MEMBER_REFERRAL" }]],
  },
  {
    key: "estate",
    label: "sidebar.estate",
    leftIcon: faCity,
    requiredPermissionSets: [[{ section: "ESTATE", function: "LIST" }]],
  },
  {
    key: "sinoParking",
    label: "sidebar.sinoclubparking",
    leftIcon: faSquareParking,
    requiredPermissionSets: [[{ section: "SINO_CLUB", function: "LIST_PARKING" }]],
  },
  {
    key: "spendingTransaction",
    label: "sidebar.spendingTransaction",
    leftIcon: faReceipt,
    requiredPermissionSets: [[{ section: "SPENDING_TRANSACTION", function: "LIST" }]],
  },
  {
    key: "campaignCode",
    label: "sidebar.campaignCode",
    leftIcon: faRectangleList,
    requiredPermissionSets: [[{ section: "CAMPAIGN_CODE", function: "LIST" }]],
  },
  {
    key: "gift",
    label: "sidebar.gift",
    leftIcon: faGift,
    requiredPermissionSets: [[{ section: "GIFT", function: "LIST" }]],
  },
  {
    key: "onlineEnquiry",
    label: "sidebar.onlineEnquiry",
    leftIcon: faQuestionCircle,
    requiredPermissionSets: [],
  },
  {
    key: "mall",
    label: "sidebar.mall",
    leftIcon: faBuilding,
    requiredPermissionSets: [[{ section: "SHOP", function: "LIST" }]],
  },
  {
    key: "shop",
    label: "sidebar.shop",
    leftIcon: faHome,
    requiredPermissionSets: [[{ section: "SHOP", function: "LIST" }]],
  },
  {
    key: "sdollar",
    label: "sidebar.sdollar",
    leftIcon: faDollarSign,
    requiredPermissionSets: [[{ section: "S_COUPON_AND_S_DOLLAR_SHOPS", function: "LIST" }]],
  },
  {
    key: "coupon",
    label: "sidebar.sCoupon",
    leftIcon: faTicketAlt,
    requiredPermissionSets: [[{ section: "S_COUPON", function: "LIST" }]],
  },
  {
    key: "Banner",
    label: "sidebar.banner",
    leftIcon: faImage,
    requiredPermissionSets: [[{ section: "BANNER", function: "LIST" }]],
  },
  {
    key: "dynamicBannerList",
    label: "sidebar.bannerList",
    leftIcon: faImages,
    requiredPermissionSets: [[{ section: "BANNER_LIST", function: "LIST" }]],
  },
  {
    key: "crazyAd",
    label: "sidebar.crazyAd",
    leftIcon: faAd,
    requiredPermissionSets: [[{ section: "CRAZY_AD", function: "LIST" }]],
  },
  {
    key: "mission",
    label: "sidebar.mission",
    leftIcon: faBullseye,
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    key: "stamp",
    label: "sidebar.stamp",
    leftIcon: faStamp,
    requiredPermissionSets: [[{ section: "ACTIVITY", function: "LIST" }]],
  },
  {
    key: "unpublishedPrivilege",
    label: "sidebar.unpublishedPrivilege",
    leftIcon: faGem,
    requiredPermissionSets: [[{ section: "EXCLUSIVE_REWARD", function: "LIST" }]],
  },
  {
    key: "memberTags",
    label: "sidebar.memberTags",
    leftIcon: faCertificate,
    requiredPermissionSets: [[{ section: "MEMBER_TAG", function: "LIST" }]],
  },
  {
    key: "spendingPointBonusRule",
    label: "sidebar.spendingPointBonusRule",
    leftIcon: faSuperscript,
    requiredPermissionSets: [[{ section: "BONUS_RULE", function: "LIST" }]],
  },
  {
    key: "contactlessParking",
    label: "sidebar.contactlessParking",
    leftIcon: faCarRear,
    requiredPermissionSets: [[{ section: "CONTACTLESS_PARKING", function: "LIST" }]],
  },
  {
    key: "parkingRecord",
    label: "sidebar.createParkingRecords",
    leftIcon: faParking,
    requiredPermissionSets: [[{ section: "PARKING_RECORDS", function: "LIST" }]],
  },
  {
    key: "checkInEvent",
    label: "sidebar.checkInEvent",
    leftIcon: faCalendarCheck,
    requiredPermissionSets: [[{ section: "CHECK_IN_EVENT", function: "VIEW_DETAILS" }]],
  },
  {
    key: "user",
    label: "sidebar.user",
    leftIcon: faUser,
    requiredPermissionSets: [[{ section: "USER", function: "LIST" }]],
  },
  {
    key: "userNotification",
    label: "sidebar.userPushRecord",
    leftIcon: faBell,
    requiredPermissionSets: [[{ section: "USER_PUSH_RECORD", function: "LIST" }]],
  },
  {
    key: "userInboxMessage",
    label: "sidebar.userInboxMessage",
    leftIcon: faInbox,
    requiredPermissionSets: [[{ section: "USER_INBOX_MESSAGE", function: "LIST" }]],
  },
  {
    key: "merchantNotification",
    label: "sidebar.merchantPushRecord",
    leftIcon: faBell,
    requiredPermissionSets: [[{ section: "USER_PUSH_RECORD", function: "LIST" }]],
  },
  {
    key: "merchantInboxMessage",
    label: "sidebar.merchantInboxMessage",
    leftIcon: faInbox,
    requiredPermissionSets: [[{ section: "USER_INBOX_MESSAGE", function: "LIST" }]],
  },
  {
    key: "merchantCustomReferralPoint",
    label: "sidebar.merchantCustomReferralPoint",
    leftIcon: faPlus,
    requiredPermissionSets: [[{ section: "CUSTOM_REFERRAL_BONUS_POINT", function: "LIST" }]],
  },
  {
    key: "thirdPartyIntegrator",
    label: "sidebar.thirdPartyIntegrator",
    leftIcon: faUserCircle,
    requiredPermissionSets: [[{ section: "THIRD_PARTY_INTEGRATOR", function: "LIST" }]],
  },
  {
    key: "OCR_Test",
    label: "sidebar.ocrTest",
    leftIcon: faUserCircle,
    requireSuperPlusAdmin: true,
  },
];
if (process.env.REACT_APP_SHOW_MALL_SECTION === "false") {
  options = options.filter((value) => value.key !== "mall");
}

export default options;
